import { Flex, Stack, createStyles } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

import { Button } from '~/domains/design-system/Button';
import repeat from '~/common/utils/repeat';
import { Title } from '~/domains/design-system/Title';
import IconLock from '~/domains/design-system/icons/IconLock';

import type { BaseField, FieldDescriptor } from '../../types/common';

export type UneditableSettingsFieldsType = BaseField & {
  type: 'UneditableSettingsFields';
};

const useStyles = createStyles((theme) => ({
  card: {
    minHeight: 48,
    width: '100%',
    paddingLeft: theme.other.spacing._12,
    paddingRight: theme.other.spacing._12,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    borderRadius: theme.radius.sm,
    border: `1px solid ${theme.colors.gray[7]}`,
    textAlign: 'left',
  },
  labelWrapper: {
    width: '100%',
  },
  box: {
    backgroundColor: theme.colors.gray[6],
    filter: 'blur(2px)',
    opacity: 0.2,
    padding: theme.other.spacing._8,
    pointerEvents: 'none',
    borderRadius: theme.radius.sm,
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  },
  wrapper: {
    position: 'relative',
    zIndex: 0,
  },
  icon: {
    backgroundColor: theme.white,
    borderRadius: '50%',
    width: 64,
    height: 64,
  },
}));

function UneditableSettingsFields() {
  const { classes, cx, theme } = useStyles();

  return (
    <div className={classes.wrapper}>
      <Flex
        align="center"
        justify="center"
        direction="column"
        gap={theme.other.spacing._24}
        className={classes.content}
      >
        <Flex align="center" justify="center" className={classes.icon}>
          <IconLock size={24} />
        </Flex>
        <Title variant="headline-xxl">{`Can't edit`}</Title>
      </Flex>
      <div className={classes.box}>
        <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={10}>
          {repeat(6, (index) => (
            <Button key={index} variant="text" className={cx(classes.card)}>
              <Flex align="center" justify="space-between">
                <div />
                <IconChevronDown size={18} stroke={theme.colors.gray[4]} />
              </Flex>
            </Button>
          ))}
        </Stack>
      </div>
    </div>
  );
}

const Descriptor: FieldDescriptor<UneditableSettingsFieldsType> = {
  FieldComponent: UneditableSettingsFields,
  name: 'UneditableSettingsFields',
};

export default Descriptor;
